import { Check, Star } from 'lucide-react';
import { toggleFavorite } from '@/db/repositories/favorites';
import { toggleLearned } from '@/db/repositories/progress';

interface ToggleProps {
  signId: string;
  active: boolean;
}

/** Favoritar (F15-T01). */
export function FavoriteButton({ signId, active }: ToggleProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={() => void toggleFavorite(signId)}
      aria-pressed={active}
      className={`flex min-h-12 flex-1 items-center justify-center gap-2 rounded-xl text-sm font-medium transition-colors ${
        active ? 'bg-amber-400/15 text-amber-300' : 'bg-slate-800 text-slate-300 active:bg-slate-700'
      }`}
    >
      <Star size={18} aria-hidden className={active ? 'fill-amber-400 text-amber-400' : undefined} />
      {active ? 'Favorito' : 'Favoritar'}
    </button>
  );
}

/** Marcar como aprendido (F15-T05, F15-T06). */
export function LearnedButton({ signId, active }: ToggleProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={() => void toggleLearned(signId)}
      aria-pressed={active}
      className={`flex min-h-12 flex-1 items-center justify-center gap-2 rounded-xl text-sm font-medium transition-colors ${
        active
          ? 'bg-emerald-400/15 text-emerald-300'
          : 'bg-slate-800 text-slate-300 active:bg-slate-700'
      }`}
    >
      <Check size={18} aria-hidden />
      {active ? 'Aprendido' : 'Marcar aprendido'}
    </button>
  );
}
